import React from "react";
import autobind from "react-autobind";
import {
  ListTable,
  Actions,
  ActionButton,
  Modal,
  PageTitle,
  PencilIcon,
  OptionsTransform,
} from "@gsd/backoffice-ui";
import { Column } from "react-table";
import { Col, Row, Button } from "reactstrap";
import ColumnsSettings from "./TableSettings";
import FormAcl from "./FormAcl";

type Props = {
  dataElements: Array<unknown>;
  loading?: boolean;
  upsertElement: Function;
  applications: Array<{ uid?: any; name?: string }>;
};

type State = {
  activeDataElement: any;
  readOnly: boolean;
  editModalOpen: boolean;
};

class Acls extends React.Component<Props, State> {
  state: State;
  constructor(props: Props) {
    super(props);
    this.state = {
      activeDataElement: null,
      readOnly: false,
      editModalOpen: false,
    };
    autobind(this);
  }

  tableActions: Array<Column> = [
    {
      Header: "Modifica",
      Cell: (row) => {
        return (
          <Actions>
            <ActionButton
              icon={PencilIcon}
              onClick={() => this.handleEdit(row.original)}
            />
          </Actions>
        );
      },
      sortable: false,
      width: 75,
    },
    {
      Header: "Applicazione",
      id: "appName",
      accessor: (data) => {
        const app = this.props.applications.find((app) => {
          return app.uid === data.applicationUid;
        });
        return (app || {}).name || data.applicationUid;
      },
      width: 150,
    },
  ];

  handleEdit(row?: any) {
    this.setState({
      ...this.state,
      editModalOpen: true,
      activeDataElement: row || {},
    });
  }

  onCloseModal() {
    this.setState({
      ...this.state,
      editModalOpen: false,
    });
  }

  onSaveData(values: any) {
    this.props.upsertElement(values);
    this.onCloseModal();
  }

  render() {
    const { dataElements, applications } = this.props;
    const { editModalOpen, activeDataElement = {}} = this.state;

    return (
      <React.Fragment>
        <Row className="pb-3">
          <Col xs="9">
            <PageTitle title="Lista Controllo Accessi [ ACL ]" />
          </Col>
          <Col xs="3">
            <Button color="primary" size="lg" block onClick={this.handleEdit}>
              Nuova Acl
            </Button>
          </Col>
        </Row>
        <ListTable
          columns={ColumnsSettings}
          data={dataElements}
          actions={this.tableActions}
        />
        <Modal
          showModal={editModalOpen}
          onClose={() => this.onCloseModal()}
          size="lg"
          title="Modifica Ruolo"
        >
          <FormAcl
            initialValues={activeDataElement}
            onSubmit={this.onSaveData}
            applicationOpts={OptionsTransform(applications, "name", "uid")}
          />
        </Modal>
      </React.Fragment>
    );
  }
}
export default Acls;
